import {useI18n} from 'i18n/I18nContext'
import React, {useEffect, useMemo, useState} from 'react'
import styled from 'styled-components'
import {attendeeApiClient} from 'attendee/apiClient'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import Page from 'attendee/theme/Page'
import PurchaseItem, {PurchaseItemType} from 'attendee/Purchases/PurchaseItem'

export function Purchases() {
  const {t} = useI18n()
  const {products, loading} = useGetPurchases()

  if (loading) {
    return <FullPageLoader />
  }

  return (
    <Page>
      <section className="event__schedule-area dark_light_class pt-55 pb-150">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-7 col-xl-7 col-lg-6">
              <h2 className="section__title mb-35">
                {t('attendee.purchasesTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('attendee.purchasesTitleHighlight')}
                </span>
              </h2>
            </div>

            {products && products.length === 0 ? (
              <EmptyState>{t('attendee.purchasesEmpty')}</EmptyState>
            ) : (
              <Grid>
                {products?.map((product) => <PurchaseItem product={product} />)}
              </Grid>
            )}
          </div>
        </div>
      </section>
    </Page>
  )
}

function useGetPurchases() {
  const apiClient = useMemo(() => attendeeApiClient(), [])
  const [products, setProducts] = useState<PurchaseItemType[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiClient.get(`api/products`)
        setProducts(response)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [apiClient])

  return {products, loading}
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 8rem 0;
  font-size: 1.2rem;
  color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
`
